<template>


    <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Файлы</span>

            </h3>
<!--            <div class="card-toolbar">-->
<!--                <b-button variant="primary">Загрузить</b-button>-->
<!--            </div>-->
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body pt-0">

            <div v-if="load" class="text-center mb-10">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>

            <div v-else class="row">

                <div v-bind:key="i" v-for="(file, i) in files" class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                    <div class="card card-custom gutter-b card-stretch">
                        <div class="card-body pt-4">


                            <div class="d-flex align-items-center mb-7">
                                <b-img :src="$urlBackEnd(file.thumbnail)" fluid-grow alt="Fluid-grow image"></b-img>
                            </div>

                            <div class="mb-7">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="text-dark-75 font-weight-bolder mr-2">#:</span>
                                    <a href="#" class="text-muted text-hover-primary">{{ file.id }}</a>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="text-dark-75 font-weight-bolder mr-2">Дата загрузки:</span>
                                    <a href="#" class="text-muted text-hover-primary">{{ moment(file.created_at).format('lll') }}</a>
                                </div>
                                <div class="d-flex justify-content-between align-items-cente my-1">
                                    <span class="text-dark-75 font-weight-bolder mr-2">Пользователь:</span>
                                    <router-link :to="{ name: 'EditAccount', params: {id: file.user_id}}" class="text-muted text-hover-primary">{{file.user.name}}</router-link>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="text-dark-75 font-weight-bolder mr-2">Размер:</span>
                                    <span class="text-muted font-weight-bold">{{converter(file.size)}}</span>
                                </div>
                            </div>
                            <!--end::Info-->
                            <a @click="deleteFileShow(file.id)" class="btn btn-block btn-sm btn-light-danger font-weight-bolder text-uppercase py-4">Удалить файл</a>
                        </div>
                        <!--end::Body-->
                    </div>
                    <!--end::Card-->
                </div>

            </div>

            <Paginate v-if="load === false" :route_link="'Files'" :filter="filter" />

        </div>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить файл: #{{modalFileId}}?</h3>
                <p>Внимание! Убедитесь что файл не используется.</p>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideModal" >Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteFile" >Удалить</b-button>
                </b-col>
            </b-row>

        </b-modal>

    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
    import {DELETE_FILE, GET_FILES} from "../../../core/services/store/files.module";
    import moment from "moment";
    require('moment/locale/ru');
    import { mapGetters } from "vuex";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import Paginate from "../Paginate";
    export default {
        name: "Files",
        components: {Paginate},
        mounted(){


            this.getFilter();
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Файлы" }])

        },

        computed: {
            ...mapGetters({
                paginate: 'paginateGetters',
                files: 'gettersFiles',
                load: 'getFilesLoad',
                errors: 'errorsFiles',
            }),
        },

        methods:{


            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            async getFilter(){
                try {
                    await this.$store.dispatch(GET_FILES, {'page': this.$route.params.page, 'filter': this.filter})
                    if (this.files.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'Files', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

            converter(length) {
                var i = 0, type = ['б','Кб','Мб','Гб','Тб','Пб'];
                while((length / 1000 | 0) && i < type.length - 1) {
                    length /= 1024;
                    i++;
                }
                return length.toFixed(2) + ' ' + type[i];
            },

            deleteFileShow(id){
                this.modalFileId = id;
                this.$refs['delete-modal'].show()
            },

            hideModal() {
                this.modalFileId = '';
                this.$refs['delete-modal'].hide()
            },

            deleteFile(){
                this.$store.dispatch(DELETE_FILE, this.modalFileId)
                    .then(() => {
                        this.getFilter();
                        this.showAlert('Файл успешно удален', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка удаления', 'danger', 'toast');
                    })
                    .finally(() => {
                        this.hideModal()
                    })
            }

        },

        data() {
            return {
                moment:moment,

                modalFileId: '',

                filter: {
                    to: '50',
                    trashed: false,
                },
            }
        },


        watch: {

            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            },
        }

    }
</script>

<style scoped>

</style>